<template>
  <div class="table offer-info" style="margin-top: 1em;">
    <el-row v-if="['capacityAnalysis','costBreakdown'].indexOf(type)>=0 ">
      <div style="vertical-align: middle;display: inline-block">
        <el-button v-if="isSupplier" @click="downloadTemplate()" type="primary">{{$t('ssrManage.supDownloadTemplate')}}</el-button>
        <el-button v-if="!isSupplier &&c_files != null && c_files.length>0" @click="downloadAll(roundId)" type="primary">Download Attachments</el-button>
      </div>
      <div class="uploadContainer" style="vertical-align: middle;display: inline-block;margin-left: 10px; line-height: 0;">
        <el-upload style="display: inline-block;" v-if="isSupplier && canEdit" :headers="uploadHeader" :show-file-list="false" :http-request="updateTemplate">
          <el-button style="vertical-align: middle;padding-right: 10px;" slot="trigger" type="primary">Upload</el-button>
        </el-upload>
      </div>
      <div v-for="file of c_files" style="display: inline-block;">
        <el-button style="margin-left: 1em;" @click="download(file)" type="text">{{file.documentName}}</el-button>
        <el-button v-if="isSupplier && canEdit" type="danger" @click="deleteFile(file)" icon="el-icon-delete" circle></el-button>
      </div>
    </el-row>
    <el-form :model="c_data" ref="form">
      <el-table :data="c_data" ref="table" border highlight-current-row style="margin-top:15px;">
        <el-table-column type="selection" v-if="c_canEdit"></el-table-column>
        <el-table-column v-for="(column,index) in c_template.columns" :min-width="50+(column.length*20<100?100:column.length*20)" :column-key="column" :label="column" v-if="template.columns[index] != null">
          <template slot-scope="scope">
            <div v-if="type == 'capacityAnalysis' && index==0" class="el-input el-input--small is-disabled">
              <el-form-item :prop="`[${scope.$index}].data.columns[${index}]`" :rules="requiredRule">
                <input class="el-input__inner" disabled :value="scope.row.data.columns[index]" />
              </el-form-item>
            </div>
            <div v-else-if="type == 'capacityAnalysis' && index==1 && c_canEdit">
              <el-form-item :prop="`[${scope.$index}].data.columns[${index}]`" :rules="requiredRule">
                <el-select v-model="scope.row.data.columns[index]" :disabled="!c_canEdit">
                  <el-option :label="'Please select'" value=""></el-option>
                  <el-option v-for="plant in myPlants" :key="plant.tmSupplierId" :label="plant.supplierName" :value="plant.supplierName"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-else-if="type == 'costBreakdown' && (index==0 || index==2)" class="el-input el-input--small" :class="c_canEdit?'':'is-disabled'">
              <el-form-item :prop="`[${scope.$index}].data.columns[${index}]`" :rules="requiredRule">
                <input class="el-input__inner" :disabled="!c_canEdit" v-model="scope.row.data.columns[index]" />
              </el-form-item>
            </div>
            <div v-else-if="type == 'costBreakdown' && index==1" class="el-input el-input--small" :class="c_canEdit?'':'is-disabled'">
              <el-form-item :prop="`[${scope.$index}].data.columns[${index}]`">
                <MaterialInput :disabled="!c_canEdit" v-model="scope.row.data.columns[index]" @pick="changeMaterial($event,scope.row)"></MaterialInput>
              </el-form-item>
            </div>
            <div v-else-if="type == 'costBreakdown' && index==totalColIndex" class="el-input el-input--small" :class="c_canEdit?'':'is-disabled'">
              <el-form-item :prop="`[${scope.$index}].data.columns[${index}]`" :rules="requiredRule">
                <input class="el-input__inner" :disabled="!c_canEdit" v-model="scope.row.data.columns[index]" />
              </el-form-item>
            </div>
            <div v-else class="el-input el-input--small" :class="c_canEdit?'':'is-disabled'">
              <el-form-item :prop="`[${scope.$index}].data.columns[${index}]`" :rules="commonColumnRules(index)">
                <input class="el-input__inner" @change="costBreakdownChange(scope.$index)" :disabled="!c_canEdit" :style="capacityStyle(index,scope.row.data.columns[index])" v-model="scope.row.data.columns[index]" />
              </el-form-item>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import router from '../../../router';
import { apiService } from "@/api/ssr-manage/ssr-manage";
import { Message } from "element-ui";
import commonMethods from "@/utils/commonMethods";
import { materialService } from "@/api/base-data/material";
import commonFun from "@/utils/commonFun";
import { fileService } from "@/api/common/file-utils";
import FileList from "@/components/common/fileList";
import MaterialInput from "@/components/page/base-data/materialInput";

export default {
  name: 'capacity-table',
  extends: commonMethods,
  components: { MaterialInput, FileList },
  props: {
    roundId: Number,
    suppliers: Array,
    template: Object,
    data: Array,
    type: String,
    canEdit: Boolean,
    myPlants: Array,
    files: Array,
  },
  computed: {
    totalColIndex() {
      return this.template.columns.filter(column => commonFun.isNotEmpty(column)).length - 1;
    },
    fileType() {
      return this.type == "costBreakdown" ? "SUPPLIER_COST" : "SUPPLIER_CAPACITY";
    },
    commonColumnRules() {
      let that = this;
      return (index) => {
        if (that.type == "capacityAnalysis") {
          return that.c_template.useRatioIndexList.indexOf(index) >= 0 ? [that.requireRule, that.useRatioRule] : [that.requireRule];
        } else if (this.type == "costBreakdown") {
          return [that.requireRule, this.numberRule];
        }
      }
    },
    capacityStyle() {
      let that = this;
      return (index, val) => {
        if (that.type == 'capacityAnalysis' && that.c_template.useRatioIndexList.indexOf(index) >= 0) {
          if (commonFun.isNotEmpty(val) && !isNaN(val)) {
            if (val <= 60) {
              return {
                "background-color": '#67C23A',
                color: '#FFFFFF !important'
              };
            } else if (val <= 80) {
              return {
                "background-color": '#E6A23C',
                color: '#FFFFFF !important',
              };
            } else if (val) {
              return {
                "background-color": '#FB4E4E',
                color: '#FFFFFF !important',
              };
            }
          }
        }
      }
    }
  },
  data() {
    return {
      c_files: this.files,
      c_canEdit: false,
      c_template: {},
      c_data: [],
      c_suppliers: [],
      useRatioIndexs: [],
      test: null,
      requiredRule: [{ required: true, message: 'Can not be empty!', trigger: 'blur' }],
      requireRule: { required: true, message: 'Can not be empty!', trigger: 'blur' },
      numberRule: {
        required: true, validator: (rule, value, callback) => {
          if (isNaN(value) || value < 0) {
            callback('Number error!');
          }
          callback();
        }, trigger: 'change'
      },
      useRatioRule: {
        validator: (rule, value, callback) => {
          let isError = false;
          if (isNaN(value) || value < 0) {
            isError = true;
          } else if (value < 0 || isNaN(value)) {
            isError = true;
          }
          if (isError) {
            callback(this.$t("ssrManage.useRatioError"));
          } else {
            callback();
          }
        }, trigger: 'blur'
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    download(file) {
      fileService.downloadFile(file);
    },
    deleteFile(file) {
      let that = this;
      fileService.deleteFile(file.tmDocumentId).then(res => {
        that.c_files = [];
        that.$emit("update:files", that.c_files);
      });
    },
    downloadTemplate() {
      let ssr = this.$store.state.ssr.data;
      let files = this.type == "costBreakdown" ? ssr.costBreakdownFiles : ssr.capacityAnalysisFiles;
      if (commonFun.isEmpty(files)) {
        Message.warning(this.$t('ssrManage.noCapacityFiles'));
      } else if (files.length == 1) {
        fileService.downloadFile(files[0]);
      } else {
        fileService.downLoadZip({ recIds: [ssr.ttSsrId], tsReckindId: 'SSR', seq: this.type == "costBreakdown" ? "COST_BREAKDOWN" : "CAPACITY_ANALYSIS", zipName: ssr.name })
      }
      // fileService.downloadFile();
      // apiService.downloadTemplate("Capacity Analysis");
    },
    updateTemplate(item) {
      let that = this;
      let formData = new FormData();
      formData.append("file", item.file);
      formData.append("single", true);
      fileService.fileUploadWithReplationShip("SSR", this.suppliers[0].ttSsrRoundSupplierId, that.fileType, formData).then((res) => {
        let promises = [];
        res.data.forEach(file => {
          let fileName = that.suppliers[0].supplierName + "-" + file.documentName;
          file.documentName = fileName;
          promises.push(fileService.changeFileName(fileName, file.tmDocumentId));
        });
        Promise.all(promises).then(() => {
          Message.success('Upload Success');
          this.c_files = res.data;
          that.$emit("update:files", that.c_files);
        })
      });
    },
    downloadAll(roundId) {
      if (this.fileType == "SUPPLIER_CAPACITY") {
        apiService.downloadRoundSupplierCapacityFile(roundId);
      } else if (this.fileType == "SUPPLIER_COST") {
        apiService.downloadRoundSupplierCostBreakdownFile(roundId);
      }
    },
    uploadCapacityFile(index) {
      let that = this;
      return (item) => {
        let formData = new FormData();
        formData.append("file", item.file);
        let row = that.c_data[index];
        if (commonFun.isEmpty(row.data.capacityFiles)) {
          row.data.capacityFiles = [];
        }
        if (row.ttCapacityId != null) {
          fileService.fileUploadWithReplationShip("SSR", row.ttCapacityId, "SUPPLIER_CAPACITY", formData).then((res) => {
            let supplierNameShort = JSON.parse(localStorage.getItem("supplierObj")).supplierNameShort;
            res.data.forEach(file => {
              file.documentName = `${supplierNameShort}-${file.documentName}`;
              fileService.changeFileName(file.documentName, file.tmDocumentId);
            })
            row.data.capacityFiles.push(...res.data);
          });
        } else {
          let formData = new FormData();
          formData.append("file", item.file);
          fileService.fileUpload(formData).then((res) => {
            let supplierNameShort = JSON.parse(localStorage.getItem("supplierObj")).supplierNameShort;
            res.data.forEach(file => {
              file.documentName = `${supplierNameShort}-${file.documentName}`;
            })
            that.c_data[index].data.capacityFiles.push(...res.data);
          });
        }
      }
    },
    costBreakdownChange(index) {
      if (this.type == 'costBreakdown') {
        let columns = this.c_data[index].data.columns;
        let total = 0;
        for (var i = 3; i < this.totalColIndex; i++) {
          let data = columns[i];
          if (!isNaN(data)) {
            total -= (-data);
          }
        }
        this.$set(this.c_data[index].data.columns, this.totalColIndex, total);
      }
    },
    init() {
      this.c_canEdit = this.canEdit;
      this.c_template = this.template;
      this.c_data = this.data;
      this.c_suppliers = this.supplier;
    },
    delSelect() {
      let selectRows = this.$refs.table.selection;
      if (selectRows.length == 0) {
        Message.warning('Please select data!');
      }
      selectRows.forEach(row => {
        this.c_data.splice(this.c_data.findIndex(tmp => tmp == row), 1);
      });
    },
    changeMaterial(material, row) {
      let that = this;
      if (commonFun.isNotEmpty(material)) {
        if (commonFun.isNotEmpty(material.eightBitCodeName)) {
          row.data.columns.splice(0, 1, material.eightBitCodeName);
        } else {
          materialService.getDetailForPqcp(material.eightBitCode).then(res => {
            if (res.code == 200 && commonFun.isNotEmpty(res.data)) {
              row.data.columns.splice(0, 1, res.data.productDescription);
            } else {
              row.data.columns.splice(0, 1, "");
              Message.error(that.$t("ssrManage.eightBitCodeError"));
            }
          })
        }
      } else {
        row.data.columns.splice(0, 1, "");
      }
    }
  },
  watch: {
    files(val) {
      this.c_files = this.files;
    },
    template(val) {
      this.c_template = this.template;
    },
    data(val) {
      this.c_data = this.data;
    },
    canEdit(val) {
      this.c_canEdit = this.canEdit;
    },
    c_data(val) {
      this.$emit("update:data", this.c_data);
    },
    suppliers(val) {
      this.c_suppliers = this.suppliers;
    }
  }
}
</script>
<style>
.uploadContainer .el-upload {
  display: block;
}
/*.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{*/
/*    margin-bottom: 0;*/
/*}*/
</style>
